export function getLocalUptime (state) {
    return state.uptime
}